import cs from 'classnames';
import type { FC, ReactNode } from 'react';
import { Chip, Container } from '@/DesignSystem/Component';
import { IconGradOne, IconHumanities, IconMath, IconOloum } from '@/Module/Icon';
import { useAppSelector } from '@/Module/Store/Hook';
import TeacherListByCategory from '@/Module/Teacher/Component/TeacherList/TeacherListByCategory';
import type { ITeacherCategoryListCategory } from '@/Module/Teacher/Model/DataModel/ITeacherCategoryList';
import { categoryTeacherListSelectByCategoryId } from '@/Module/Teacher/Store/Selector';
export type ITeacherColor = 'primary' | 'orange' | 'pink';
const TITLE_COLORS: Record<ITeacherColor, string> = {
  orange: 'text-orangeFive ',
  pink: 'text-pinkFive',
  primary: 'text-blueFive'
};
const ICON_COLORS: Record<ITeacherColor, string> = {
  orange: 'bg-orangeTwo text-orangeFive',
  pink: 'bg-pinkTwo text-pinkFive',
  primary: 'text-blueFive bg-blueTwo '
};
const ICONS: Record<ITeacherCategoryListCategory['id'], ReactNode> = {
  2: <IconGradOne size="small" />,
  18: <IconMath size="small" />,
  19: <IconHumanities size="small" />,
  20: <IconOloum size="small" />
};
interface IProps {
  id: ITeacherCategoryListCategory['id'];
}
const TeacherRowByCategory: FC<IProps> = ({
  id
}) => {
  const categoryTeacher = useAppSelector(state => categoryTeacherListSelectByCategoryId(state, id));
  if (!categoryTeacher?.teacherList?.ids) return null;
  const {
    title,
    color
  } = categoryTeacher.category;
  return <Container key={id} data-sentry-element="Container" data-sentry-component="TeacherRowByCategory" data-sentry-source-file="TeacherRowByCategory.tsx">
      <div className="my-8 flex flex-col ">
        <div className="mb-6 flex flex-row items-center sm:pr-16">
          <span className={cs('inline-flex rounded-md p-2', ICON_COLORS[color])}>{ICONS?.[id]}</span>
          <Chip title={title} className={cs('text-2xl', TITLE_COLORS[color])} data-sentry-element="Chip" data-sentry-source-file="TeacherRowByCategory.tsx" />
        </div>

        <TeacherListByCategory id={id} data-sentry-element="TeacherListByCategory" data-sentry-source-file="TeacherRowByCategory.tsx" />
      </div>
    </Container>;
};
export default TeacherRowByCategory;